// @flow
import styled from "styled-components";
import Checkbox from "../Form/Checkbox";

export const IgnoreCheckbox = styled(Checkbox)`

`;

export default IgnoreCheckbox;